import { useScreenViewEvent } from '@stitch-fix/event-reporter';

export type LandingScreenViewTrackingProps = {
  contentId?: 'refresh' | 'giveget_refresh' | 'refresh_results';
  name?:
    | 'landing'
    | 'corporate'
    | 'signup'
    | 'login'
    | 'password_reset'
    | 'public_stylefile'
    | 'stylefile_core'
    | 'stylefile_giveget'
    | 'stylefile_intro';
  children: React.ReactNode;
};

export const LandingScreenViewTracking = ({
  contentId,
  name = 'landing',
  children,
}: LandingScreenViewTrackingProps) => {
  const { EventProvider } = useScreenViewEvent({
    schema: 'screen_view',
    name,
    locale: 'en-US',
    region: 'US',
    source_app: 'growth-next-ui',
    content_id: contentId,
  });

  return <EventProvider>{children}</EventProvider>;
};
